import gql from 'graphql-tag'

export const CREATE_HALL = gql`
  mutation CreateHall($eventId: ID!, $input: CreateHallInput!) {
    createHall(input: $input, eventId: $eventId) {
      id
    }
  }
`
export const DELETE_HALL = gql`
  mutation DeleteHall($hallId: ID!) {
    deleteHall(hallId: $hallId)
  }
`

export const UPDATE_HALL = gql`
  mutation UpdateHall($hallId: ID!, $input: UpdateHallInput!) {
    updateHall(hallId : $hallId, input: $input){
        id
    }
  }
`

export const GET_EVENT_HALLS = gql`
  query GetHalls($eventId: ID!) {
    getHalls(eventId: $eventId) {
        id
        name
        color
        image
        createdAt
        updatedAt
    }
  }
`

export const GET_EVENT_HALL = gql`
  query GetHall($eventId: ID!, $hallId: ID!){
    getHall(eventId: $eventId, hallId: $hallId){
        id
        name
        color
        image
        createdAt
        updatedAt
    }
  }
`

export const SEARCH_HALLS = gql`
  query SearchHalls($eventId: ID!, $name: String!){
    searchHalls(eventId: $eventId, name: $name){
      id
      name
    }
  }
`
